import React, { Fragment, PureComponent } from 'react'
import { Grid, LinearProgress } from '@material-ui/core'

import { RouteButton } from 'components'

export class RoutesBase extends PureComponent {
  renderLoading = (
    <Grid item xs>
      <LinearProgress />
    </Grid>
  )

  renderFromUaRoutes = routes => (
    <Grid
      item
      container
      xs={12}
      wrap='nowrap'
    >
      {routes.filter(({ type }) => type === 'ua').map(this.renderRoute)}
    </Grid>
  )

  renderToUaRoutes = routes => (
    <Grid
      item
      container
      xs={12}
      wrap='nowrap'
    >
      {routes.filter(({ type }) => type !== 'ua').map(this.renderRoute)}
    </Grid>
  )

  renderRoute = route => (
    <Grid
      xs
      item
      key={route.id}
    >
      <RouteButton route={route}>
        {route.label}
      </RouteButton>
    </Grid>
  )

  render() {
    const { routes, isLoading } = this.props

    return isLoading
      ? this.renderLoading
      : (
        <Fragment>
          {this.renderFromUaRoutes(routes)}
          {this.renderToUaRoutes(routes)}
        </Fragment>
      )
  }
}



// WEBPACK FOOTER //
// ./src/components/Routes/Routes.js